class Footer {
  constructor() {
    this.initialize();
  }

  initialize() {
    const footer = $('#shopify-section-footer')
    const location = window.location.pathname;

    if(!!document.querySelector('[data-shop-product]')) {
      footer.addClass('shop')
    } else {
      if(location.includes('about')) {
        footer.addClass('about')
      } else if(location.includes('supply') || location.includes('products') && !location.includes('studio')) {
        footer.addClass('supply')
      } else if(location.includes('studio')) {
        footer.addClass('studio')
      } else if(location.includes('blog')) {
        footer.addClass('blog')
      } else {
        footer.removeClass('about')
        footer.removeClass('supply')
        footer.removeClass('studio')
        footer.removeClass('shop')
      }
    }
  }
}

const footer = new Footer();